const t = "_fieldContainer_1tg5b_1", n = "_inlineInput_1tg5b_5", e = "_editIcon_1tg5b_8", _ = "_readOnly_1tg5b_11", l = "_leadingIcon_1tg5b_26", o = "_textFilled_1tg5b_50", c = "_regular_1tg5b_57", i = "_compact_1tg5b_61", a = {
  fieldContainer: t,
  inlineInput: n,
  editIcon: e,
  readOnly: _,
  leadingIcon: l,
  textFilled: o,
  regular: c,
  compact: i
};
export {
  i as compact,
  a as default,
  e as editIcon,
  t as fieldContainer,
  n as inlineInput,
  l as leadingIcon,
  _ as readOnly,
  c as regular,
  o as textFilled
};
//# sourceMappingURL=styles.module.scss.js.map
